var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcG1CashLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7148 17.6836V24.3502L24.476 21.0174L18.7148 17.6836Z",
    fill: "#F0801B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.476 21.0167V14.3501L18.7148 17.6829L24.476 21.0167Z",
    fill: "#F6B000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4766 14.3501V21.0167L30.2387 17.6829L24.4766 14.3501Z",
    fill: "#FACC2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2387 24.3502V17.6836L24.4766 21.0174L30.2387 24.3502Z",
    fill: "#F46A83"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2383 17.6836V24.3502L35.9994 21.0174L30.2383 17.6836Z",
    fill: "#CF2A5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0004 27.6832V21.0166L30.2383 24.3494L36.0004 27.6832Z",
    fill: "#E27CAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0469 29.9995V36.6661L28.808 33.3323L23.0469 29.9995Z",
    fill: "#A33A86"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.808 33.3326V26.666L23.0469 29.9998L28.808 33.3326Z",
    fill: "#B84F8F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8066 26.666V33.3326L34.5687 29.9998L28.8066 26.666Z",
    fill: "#D07AA3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0473 36.6661V29.9995L17.2852 33.3323L23.0473 36.6661Z",
    fill: "#7D267D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2852 33.3325V40L23.0473 36.6663L17.2852 33.3325Z",
    fill: "#BBDFE7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2836 40V33.3325L11.5215 36.6663L17.2836 40Z",
    fill: "#84C7DC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5215 29.9995V36.6661L17.2836 33.3323L11.5215 29.9995Z",
    fill: "#5EB2D5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5229 36.6661V29.9995L5.76172 33.3323L11.5229 36.6661Z",
    fill: "#349EC9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76172 26.666V33.3335L11.5229 29.9998L5.76172 26.666Z",
    fill: "#2785BA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7621 33.3321V26.6655L0 29.9993L5.7621 33.3321Z",
    fill: "#135E9B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.334V30.0006L5.7621 26.6668L0 23.334Z",
    fill: "#13356F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7621 26.6666V20L0 23.3338L5.7621 26.6666Z",
    fill: "#1A8144"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.6665V23.3331L5.7621 19.9993L0 16.6665Z",
    fill: "#309641"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7621 19.9996V13.333L0 16.6668L5.7621 19.9996Z",
    fill: "#61A73D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10V16.6666L5.7621 13.3328L0 10Z",
    fill: "#9EBD31"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7621 13.3326V6.66602L0 9.99978L5.7621 13.3326Z",
    fill: "#BBCC3D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5215 3.33398V10.0006L17.2836 6.6668L11.5215 3.33398Z",
    fill: "#F6B000"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2836 6.66657V0L11.5215 3.33376L17.2836 6.66657Z",
    fill: "#FACC2E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2852 0V6.66657L23.0473 3.33376L17.2852 0Z",
    fill: "#F46A83"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76172 6.6665V13.3331L11.5229 10.0003L5.76172 6.6665Z",
    fill: "#D0D86B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5229 10.0006V3.33398L5.76172 6.6668L11.5229 10.0006Z",
    fill: "#F0801B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0473 10.001V3.33447L17.2852 6.66729L23.0473 10.001Z",
    fill: "#D02A5C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0469 3.33301V10.0005L28.809 6.66677L23.0469 3.33301Z",
    fill: "#E27CAE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.809 13.3331V6.6665L23.0469 10.0003L28.809 13.3331Z",
    fill: "#BA5693"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcG1CashLogo);
export default __webpack_public_path__ + "static/media/ic-g1cash-logo.db236707f0ed898271e0d509629b89ec.svg";
export { ForwardRef as ReactComponent };